import React, { useEffect, useState } from "react";
import CrudPage from "@/components/CrudPage";
import { housesApi, groupHomesApi } from "@/lib/orgApi";

const HousesPage = () => {
    const [groupHomes, setGroupHomes] = useState([]);
    useEffect(() => {
        groupHomesApi
            .list()
            .then(setGroupHomes)
            .catch(() => setGroupHomes([]));
    }, []);

    return (
        <CrudPage
            title="Houses"
            subtitle="Individual houses within each group home."
            api={housesApi}
            testidPrefix="houses"
            columns={[
                { key: "name", label: "Name" },
                {
                    key: "group_home_id",
                    label: "Group Home",
                    render: (r) =>
                        groupHomes.find((g) => g.id === r.group_home_id)
                            ?.name || "—",
                },
                { key: "capacity", label: "Capacity" },
                {
                    key: "active",
                    label: "Status",
                    render: (r) =>
                        r.active ? (
                            <span className="rounded-full bg-brand-green-100 px-2.5 py-1 text-xs font-semibold text-brand-green-800">
                                Active
                            </span>
                        ) : (
                            <span className="rounded-full bg-slate-200 px-2.5 py-1 text-xs font-semibold text-slate-600">
                                Inactive
                            </span>
                        ),
                },
            ]}
            fields={[
                {
                    name: "group_home_id",
                    label: "Group Home",
                    type: "select",
                    required: true,
                    options: groupHomes.map((g) => ({
                        value: g.id,
                        label: g.name,
                    })),
                },
                { name: "name", label: "House name", required: true },
                { name: "address", label: "Address" },
                { name: "capacity", label: "Capacity", type: "number" },
                {
                    name: "active",
                    label: "Active",
                    type: "boolean",
                    default: true,
                },
            ]}
        />
    );
};

export default HousesPage;
